import Inter_Regular_woff2_namespaceObject from "../../static/font/Inter-Regular.woff2";
export default Inter_Regular_woff2_namespaceObject;
